// src/utils/html.ts
import DOMPurify from 'dompurify';

// Sanitize rich-text HTML before rendering with dangerouslySetInnerHTML.
export const sanitizeHtml = (html: string): string =>
  DOMPurify.sanitize(html || '', { USE_PROFILES: { html: true } });

// Strip all tags to plain text (for card previews, meta descriptions, etc.).
export const stripHtml = (html: string): string => {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
};

// True when rich-text content is effectively empty (Quill emits "<p><br></p>").
export const isHtmlEmpty = (html: string): boolean => stripHtml(html).length === 0;
